<dx-box
    #dashboardDetailBox
    width="100%"
    height="100%"
    direction="col"
    [attr.id]="'dashboardDetailBox' + workAreaItem?.workAreaId"
>
    <dxi-item baseSize="32vh">
        <cc-data-grid-features
            [dataSource]="dashboardDetails"
            [gridFeatures]="{
                stylingMode: 'hidden',
                allowPaging: false,
                allowGrouping: false
            }"
            [pagingConfig]="{
                visible: false
            }"
        >
            <dx-data-grid
                width="100%"
                height="100%"
                class="cc-vertical-center-cell-data-grid"
                [filterSyncEnabled]="true"
                [dataSource]="dashboardDetails"
            >
                <dxi-column
                    dataField="community"
                    dataType="string"
                    caption="Community"
                    sortOrder="asc"
                    [sortIndex]="0"
                    cellTemplate="communityTemplate"
                ></dxi-column>
                <dxi-column dataField="location" dataType="string" caption="Location"></dxi-column>
                <dxi-column
                    dataField="helpKey"
                    dataType="string"
                    caption="Help"
                    alignment="center"
                    cellTemplate="helpIconTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="status"
                    dataType="string"
                    caption="Status"
                    alignment="center"
                    cellTemplate="statusIconTemplate"
                ></dxi-column>
                <dxi-column dataField="open" dataType="number" caption="Open"></dxi-column>
                <dxi-column dataField="priority" dataType="number" caption="Priority"></dxi-column>
                <dxi-column dataField="problematic" dataType="number" caption="Problematic"></dxi-column>
                <div *dxTemplate="let row of 'communityTemplate'">
                    <ng-container *ngIf="row.data.communityId > 0">
                        <app-hyperlink-creator
                            cssClass="cc-hyperlink-hover"
                            mode="hyperlinkOnly"
                            [displayText]="row.value"
                            (onLinkClick)="onCommunityClick(row.data)"
                        ></app-hyperlink-creator>
                    </ng-container>
                    <ng-container *ngIf="!(row.data.communityId > 0)">
                        <span>{{ row.value }}</span>
                    </ng-container>
                </div>
                <div *dxTemplate="let row of 'helpIconTemplate'" class="help-template-container">
                    <div class="help-icon-content" (click)="onHelpIconClick(row.data)">
                        <i [title]="row.data.helpKey" class="fas fa-question-circle dx-theme-accent-as-text-color"></i>
                    </div>
                </div>
                <div *dxTemplate="let row of 'statusIconTemplate'" class="status-template-container">
                    <div
                        [ngClass]="{
                            'status-icon-big': !row.data.isInfo,
                            'status-icon-small dx-theme-accent-as-background-color': row.data.isInfo
                        }"
                    >
                        <i
                            class="fas"
                            [ngClass]="{
                                'fa-check cc-green-icon': row.data.isOk,
                                'fa-info cc-white-icon': row.data.isInfo,
                                'fa-exclamation-triangle cc-warn-icon': row.data.isPriority,
                                'fa-flag cc-red-icon': row.data.isProblematic
                            }"
                            [title]="row.data.status"
                        ></i>
                    </div>
                </div>
            </dx-data-grid>
        </cc-data-grid-features>
    </dxi-item>
</dx-box>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#dashboardDetailBox' + workAreaItem?.workAreaId }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
